import i18n from "@/i18n";

import { CustomFilter } from "@/types/custom-filter";

import { FalconComplaintFaultMoment } from "@/enums/falcon/complaints/falcon-complaint-fault-moment.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint fault moment filter
 */
export const falconComplaintFaultMomentFilter: CustomFilter = {
  falconComplaintFaultMoment(value: any): string {
    value = +value as FalconComplaintFaultMoment;
    if (value === FalconComplaintFaultMoment.BeforeAssembly) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersComplaintFaultMomentBeforeAssemblyText
      );
    } else if (value === FalconComplaintFaultMoment.DuringAssembly) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersComplaintFaultMomentDuringAssemblyText
      );
    } else if (value === FalconComplaintFaultMoment.DuringUse) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersComplaintFaultMomentDuringUseText
      );
    } else if (value === FalconComplaintFaultMoment.AfterCollision) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersComplaintFaultMomentAfterCollisionText
      );
    } else {
      return "";
    }
    return value;
  }
};
